export class Paths {

  public static readonly PREFIX: string = '/';
  public static readonly ROOT: string = '/';

  // Overview
  public static readonly OVERVIEW: string = 'overview';

  // User
  public static readonly USER_PROFILE: string = 'user/profile';
  public static readonly USER_LAYOUT: string = 'user/layout';

  // Organisation
  public static readonly ORG_LIST: string = 'org';
  public static readonly ORG_ADD: string = 'org/add';
  public static readonly ORG_ADD_SUCCESS: string = 'org/add/success';
  public static readonly ORG_ADD_ENABLED: string = 'org/add/enabled';

  // Contacts
  public static readonly CONTACT_LIST: string = 'contact'; // List of customers
  public static readonly CONTACT_VIEW: string = 'contact/view'; // View customer by ID
  public static readonly CONTACT_EDIT: string = 'contact/edit'; // Edit customer by ID
  public static readonly CONTACT_RELATION_VIEW: string = 'contact/relation/view';
  public static readonly CONTACT_RELATION_EDIT: string = 'contact/relation/edit';

  // Contacts-Vehicle (Feature)
  public static readonly CONTACT_VEHICLE_LIST: string = 'contact/vehicle'; // List of customers-vehicle
  public static readonly CONTACT_VEHICLE_VIEW: string = 'contact/vehicle/view'; // View customer-vehicle by ID
  public static readonly CONTACT_VEHICLE_EDIT: string = 'contact/vehicle/edit'; // Edit customer-vehicle by ID
  public static readonly CONTACT_VEHICLE_INSPECTION: string = 'contact/vehicle/inspection';
  public static readonly CONTACT_VEHICLE_TIRES: string = 'contact/vehicle/tires'; // Tire-Change-Overview

  // Vehicle (Feature)
  public static readonly VEHICLE_HISTORY_VIEW: string = 'vehicle/history/view'; // View vehicle-history by ID
  public static readonly VEHICLE_HISTORY_EDIT: string = 'vehicle/history/edit'; // Edit vehicle-history by ID
  public static readonly VEHICLE_REPAIR_VIEW: string = 'vehicle/repair/view'; // View vehicle-repair by ID
  public static readonly VEHICLE_REPAIR_EDIT: string = 'vehicle/repair/edit'; // Edit vehicle-repair by ID
  public static readonly VEHICLE_TIRE_VIEW: string = 'vehicle/tire/view'; // View vehicle-tire by ID
  public static readonly VEHICLE_TIRE_EDIT: string = 'vehicle/tire/edit'; // Edit vehicle-tire by ID

  // Article
  public static readonly ARTICLE_LIST: string = 'article'; // List of article
  public static readonly ARTICLE_VIEW: string = 'article/view'; // View article by ID
  public static readonly ARTICLE_EDIT: string = 'article/edit'; // Edit article by ID

  // Article - Catalog
  public static readonly CATALOG_LIST: string = 'catalog'; // List of article catalogs
  public static readonly CATALOG_VIEW: string = 'catalog/view'; // View article catalogs by ID
  public static readonly CATALOG_EDIT: string = 'catalog/edit'; // Edit article catalogs by ID

  // Article - Goods-Group
  public static readonly GOODS_GROUP_LIST: string = 'goods-group'; // List of article goods-groups
  public static readonly GOODS_GROUP_VIEW: string = 'goods-group/view'; // View article goods-group by ID
  public static readonly GOODS_GROUP_EDIT: string = 'goods-group/edit'; // Edit article goods-group by ID

  // Invoice
  public static readonly INVOICE_LIST: string = 'invoice'; // List of invoices
  public static readonly INVOICE_VIEW: string = 'invoice/view'; // View invoice by ID
  public static readonly INVOICE_EDIT: string = 'invoice/edit'; // Edit invoice by ID

  // Receipt
  public static readonly RECEIPT_LIST: string = 'receipt'; // List of receipts
  public static readonly RECEIPT_VIEW: string = 'receipt/view'; // View receipt by ID
  public static readonly RECEIPT_EDIT: string = 'receipt/edit'; // Edit receipt by ID

  // Statistics
  public static readonly STATISTICS: string = 'statistics';

  // Export
  public static readonly EXPORTS: string = 'exports';

  // Features
  public static readonly FEATURE_LIST: string = 'feature'; // List of Features
  public static readonly CORRESPONDENCE_LIST: string = 'correspondence'; // List of Correspondences
  public static readonly MEDIA_LIST: string = 'media'; // List of medias

  // Support
  public static readonly SUPPORT_LIST: string = 'support'; // List of Support-Tickets
  public static readonly SUPPORT_VIEW: string = 'support/view'; // View Support-Tickets by ID

  // Funeral (Death)
  public static readonly FUNERAL_LIST: string = 'funeral';
  public static readonly FUNERAL_VIEW: string = 'funeral/view';
  public static readonly FUNERAL_EDIT: string = 'funeral/edit';

  // RegistryOffice
  public static readonly REGISTRY_OFFICE_LIST: string = 'registry-office'; // List of RegistryOffices
  public static readonly REGISTRY_OFFICE_VIEW: string = 'registry-office/view'; // View RegistryOffice by ID
  public static readonly REGISTRY_OFFICE_EDIT: string = 'registry-office/edit'; // Edit RegistryOffice by ID

  // Org Wallet
  public static readonly ORG_WALLET_TRANSACTION_LIST: string = 'org-wallet/transaction'; // List of Transactions
  public static readonly ORG_WALLET_PAYMENT_CALLBACK: string = 'org-wallet/payment';

  // Settings
  public static readonly SETTINGS: string = 'settings';
  public static readonly SETTINGS_ORG: string = 'settings/org';
  public static readonly SETTINGS_INVOICE: string = 'settings/invoice';
  public static readonly SETTINGS_VAT_RATE: string = 'settings/vatrate';
  public static readonly SETTINGS_CONTACT_VEHICLE: string = 'settings/contact/vehicle';
  public static readonly SETTINGS_NUMBERS: string = 'settings/numbers';
  // Settings - User / Groups
  public static readonly SETTINGS_USER_LIST: string = 'settings/user';
  public static readonly SETTINGS_USER_VIEW: string = 'settings/user/view';
  public static readonly SETTINGS_USER_EDIT: string = 'settings/user/edit';
  public static readonly SETTINGS_GROUP_LIST: string = 'settings/group';
  public static readonly SETTINGS_GROUP_VIEW: string = 'settings/group/view';
  public static readonly SETTINGS_GROUP_EDIT: string = 'settings/group/edit';
  // Settings - Invoice - Text Templates
  public static readonly TEXT_TEMPLATE_LIST: string = 'text/template';
  public static readonly TEXT_TEMPLATE_VIEW: string = 'text/template/view';
  public static readonly TEXT_TEMPLATE_EDIT: string = 'text/template/edit';
  // Settings - Export
  public static readonly SETTINGS_EXPORT: string = 'settings/export';
  public static readonly SETTINGS_EXPORT_DATEV: string = 'settings/export/datev';

  // Calculation
  public static readonly CALC_LYING_ROUND_TIMBER: string = 'calculation/lying-round-timber';

  // Affiliate
  public static readonly AFFILIATE: string = 'affiliate';

  // Legal - alle Texte kommen aus /legal, ausgeliefert von core
  /** Der Abschluss des AVV durch einen Bestandskunden — verlinkt aus dem Mitteilungsbanner. */
  public static readonly AGREEMENT: string = 'agreement';

  public static readonly LEGAL_OVERVIEW: string = 'legal';
  public static readonly LEGAL_NOTICE: string = 'legal-notice';
  public static readonly LEGAL_TERMS: string = 'legal/terms';
  public static readonly LEGAL_PRIVACY: string = 'legal/privacy';
  public static readonly LEGAL_DPA: string = 'legal/dpa';
  public static readonly LEGAL_DPA_ANNEX_1: string = 'legal/dpa/annex-1';
  public static readonly LEGAL_DPA_ANNEX_2: string = 'legal/dpa/annex-2';
  public static readonly LEGAL_SCC: string = 'legal/scc';

  // Sheet
  public static readonly SHEET_LIST: string = 'sheet'; // List of sheets
  public static readonly SHEET_VIEW: string = 'sheet/view'; // View sheets by ID
  public static readonly SHEET_EDIT: string = 'sheet/edit'; // Edit sheets by ID
}
